import { Button } from '@app/components/common/buttons/Button/Button';
import { FONT_WEIGHT } from '@app/styles/themes/constants';
import styled from 'styled-components';

export const MailLogoWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-block: 35px 24px;
  // position: absolute;
  // z-index: 9999;
  background: transparent;

  .app-logo {
    width: 200px;
  }

  @media screen and (max-width: 768px) {
    margin-block: 15px;

    .app-logo {
      width: 170px;
    }
  }
`;

export const ModelTTitle = styled.h2`
  font-weight: ${FONT_WEIGHT.bold};
  font-size: 24px;
  line-height: 29px;
  padding: 12.5px 0;
  border-bottom: 1px solid #d0d0d0;
`;

export const ButtonWrapper = styled(Button)`
  width: 100%;
  background: #1a295a;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 20px;
  font-weight: ${FONT_WEIGHT.regular};

  &:hover {
    background: #1a295a;
  }

  @media screen and (max-width: 768px) {
    font-size: 18px;
  }
`;

export const FooterWrapper = styled.div`
  padding: 0;
  margin-block: 32px 40px;
  background: 0 0;
  border-top: 1px solid #f0f0f0;
  border-radius: 0 0 7px 7px;
`;
